import { Waves, Wrench, Ruler, Container, Cable, Gauge } from "lucide-react";
import { Reveal } from "./Reveal";

const capabilities = [
  {
    n: "01",
    title: "Offshore Crane Operation",
    desc: "Pedestal, knuckle-boom and lattice cranes operated by ticketed offshore crane operators on fixed and floating installations.",
    Icon: Gauge,
  },
  {
    n: "02",
    title: "Heavy & Tandem Lifts",
    desc: "Engineered heavy-lift planning, tandem and blind lifts with full load-path and centre-of-gravity analysis.",
    Icon: Container,
  },
  {
    n: "03",
    title: "Rigging & Slinging",
    desc: "Certified riggers, banksmen and slingers. Inspected gear, colour-coded and LOLER compliant on every hitch.",
    Icon: Cable,
  },
  {
    n: "04",
    title: "Subsea & Deck Handling",
    desc: "Splash-zone deployment, deck cargo handling and back-deck operations for construction and IMR campaigns.",
    Icon: Waves,
  },
  {
    n: "05",
    title: "Inspection & Maintenance",
    desc: "Thorough examinations, load testing and preventative maintenance to keep cranes certified and offshore-ready.",
    Icon: Wrench,
  },
  {
    n: "06",
    title: "Lift Planning & Load Charts",
    desc: "Method statements, risk assessments and load charts prepared by appointed persons before a single hook is set.",
    Icon: Ruler,
  },
];

export const Capabilities = () => (
  <section
    id="capabilities"
    data-testid="capabilities-section"
    className="w-full px-6 md:px-12 py-24 md:py-40 border-t border-white/10"
  >
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
      <Reveal className="md:col-span-3">
        <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent">
          [ 001 — Capabilities ]
        </span>
      </Reveal>
      <Reveal className="md:col-span-9" delay={0.1}>
        <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
          Full-scope lifting,<br />
          <span className="text-[#64748B]">on the water.</span>
        </h2>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
      {capabilities.map((c, i) => {
        const Icon = c.Icon;
        return (
          <Reveal
            key={c.n}
            delay={(i % 3) * 0.08}
            data-testid={`capability-${c.n}`}
            className="group relative border-b border-r border-white/10 p-8 md:p-10 hover:bg-[#0A111D] transition-colors duration-400"
          >
            <div className="flex items-start justify-between mb-10">
              <span className="font-mono text-sm text-[#64748B]">{c.n}</span>
              <Icon className="text-[#64748B] group-hover:text-accent transition-colors duration-300" size={28} strokeWidth={1.4} />
            </div>
            <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-4 group-hover:text-accent transition-colors duration-300">
              {c.title}
            </h3>
            <p className="text-[#94A3B8] leading-relaxed text-sm md:text-base">
              {c.desc}
            </p>
          </Reveal>
        );
      })}
    </div>
  </section>
);
